var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useCallback } from "react";
import { Slide } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Modal from "../../../../components/modals/Modal";
import TopBar from "./TopBar";
import DrawerItem from "./DrawerItem";
import BottomNav from "./BottomNav";
import { useHeaderConfig } from "../../NavProvider";
var useStyles = makeStyles(createStyles({
    container: {
        /**
         * NOTE:
         * To prevent toolbar height changes from mobile drawer to affect the height of drawer,
         * extra height is added onto the container, and then it is deducted in the inner element.
         */
        height: "calc(100% + 100px)",
    },
    paper: {
        height: "calc(100% - 100px)",
        alignSelf: "flex-start",
        backgroundColor: "#fff",
        overscrollBehavior: "contain",
    },
    navItems: {
        marginTop: "82px",
        WebkitTextSizeAdjust: "100%",
        WebkitTapHighlightColor: "transparent",
        padding: "32px 16px 48px 16px",
    },
}));
var DrawerTransition = React.forwardRef(function (props, ref) { return (React.createElement(Slide, __assign({ direction: "right", ref: ref }, props))); });
DrawerTransition.displayName = "DrawerTransition";
var MobileDrawer = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var styles = useStyles();
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var _c = useHeaderConfig(), navItems = _c.navItems, divisions = _c.divisions, ourBrands = _c.ourBrands;
    // TODO: Hardcoding this for now
    var filteredDiv = divisions.slice(1);
    var handleClose = function () { return setShow(false); };
    var handleExited = useCallback(onClose, [onClose]);
    useEffect(function () {
        if (open)
            setShow(true);
    }, [open]);
    return (React.createElement(Modal, { disableBackdropClick: true, id: "acm-header__drawer", classes: { container: styles.container, paper: styles.paper }, open: show, onExited: handleExited, fullScreen: true, TransitionComponent: DrawerTransition },
        React.createElement(TopBar, { onClose: handleClose }),
        React.createElement("div", { className: styles.navItems }, navItems.length > 0 &&
            navItems.map(function (item, index) { return React.createElement(DrawerItem, __assign({ key: index, index: index, onClose: handleClose }, item)); })),
        React.createElement(BottomNav, { divisions: filteredDiv, ourBrands: ourBrands })));
};
export default MobileDrawer;
